import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';

import type { LearnerIncentiveNotification as LearnerIncentiveNotificationType } from 'bundles/learner-incentives/types';
import Notification from 'bundles/notification-center/components/Notification';
import type { Notification as NotificationType } from 'bundles/notification-center/types';

type Props = {
  notification: LearnerIncentiveNotificationType;
  rank?: number;
  onClick: (notification: NotificationType) => void;
};

const LearnerIncentiveNotification: React.FC<Props> = ({ notification, rank, onClick }) => {
  return (
    <Notification
      onClick={onClick}
      href={`/learn/${notification?.data?.courseSlug}/course-inbox#${notification.data.siteMessageCampaignId ?? ''}`}
      notification={notification}
      rank={rank}
    >
      <FormattedHTMLMessage message={notification.data?.message} />
    </Notification>
  );
};

export default LearnerIncentiveNotification;
